import { render, staticRenderFns } from "./MeasureEditorDialog.vue?vue&type=template&id=89b7a9ba&scoped=true&"
import script from "./MeasureEditorDialog.vue?vue&type=script&lang=js&"
export * from "./MeasureEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./MeasureEditorDialog.vue?vue&type=style&index=0&id=89b7a9ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b7a9ba",
  null
  
)

component.options.__file = "MeasureEditorDialog.vue"
export default component.exports